import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { Section } from "react-scroll-section";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <div className="smart_order_SR">
      <NewHead />

      <div className="paddin_immner">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                Smart Order Routing - Trade Crypto at the Best Price
              </title>
              <link
                rel="canonical"
                href="https://www.beleaftechnologies.com/crypto-smart-order-routing-services"
              />
              <meta
                name="title"
                content="Smart Order Routing - Trade Crypto at the Best Price "
              />
              <meta
                name="description"
                content="Beleaf’s Smart Order routing is an automated smart order routing system for cryptocurrency trading. Algorithms compare prices across exchanges and execute trades at the best price"
              />

              <meta
                property="og:title"
                content="Smart Order Routing - Trade Crypto at the Best Price "
              />
              <meta property="og:site_name" content="Beleaf Technologies" />

              <meta
                property="og:description"
                content="Beleaf’s Smart Order routing is an automated smart order routing system for cryptocurrency trading. Algorithms compare prices across exchanges and execute trades at the best price"
              />
              <meta property="og:type" content="website" />

              <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>
            <div className="ourserveic_banner ourserveic_bannernft bg_img_none bg-white NFT_first h-fit">
              {/* <div className="bg-overlay"></div> */}
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="service_content service_contentnew smart_opaddin padding_sesion">
                      <h1>
                        Crypto{" "}
                        <span className="color_blue">Smart Order Routing</span>{" "}
                        Development Company
                      </h1>
                      <p>
                        Automate and Execute your trading with an advanced
                        algorithm using Smart Order Routing System!!!
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Get Free Consultation"
                      >
                        Get Free Consultation
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex align-items-center">
                    <div className="cryptSmrtOrdrHeroSctImgWrp">
                      <img
                        src={require("../../image/cloudinary/meta2.webp")}
                        alt="Smart Order Routing Development Company"
                        className="smart_imgas cryptSmrtOrdrHeroSctImg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <section className="section bg-white">
              <div className="container">
                <div className="row cryptSmrtOrdrWhatRow">
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/cloudinary/meta3.webp")}
                      alt="Smart Contract Auditing Service Company"
                      className="What is Smart Order Routing cryptSmrtOrdrWhatImg"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">What is Smart Order Routing</h2>
                      <p className="">
                        A smart order router (SOR) is an automated method used
                        in online trading that follows a set of rules to find
                        and analyse trade liquidity. A SOR's purpose is to
                        determine the optimal method to execute a deal by
                        leveraging opportunities across many trading venues
                        using complex algorithms.
                        <br />
                        Smart Order Routing for Cryptocurrencies is the process
                        of automatically finding the best available price across
                        multiple exchanges to optimize the outcome of trading
                        any pairs. We, at Beleaf Technology, focus on the unique
                        characteristics of each trading solution as a major
                        player in Smart order routing development, which allows
                        us to attract thousands of active consumers. Get on
                        track with the super-popular features of Smart order
                        routing to meet your business objectives and set records
                        in the crypto sphere.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Join With Us"
                      >
                        Join With Us
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Smart Order Routing for Cryptocurrencies
                      </h2>
                      <p className="">
                        Beleaf Smart Order is part of Beleaf’s high-performance,
                        multi-asset trading system technology, Beleaf Terminal.
                        Beleaf Smart Order provides ultra-low latency and high
                        throughput with a full range of routing functionality,
                        placing orders based on the best available option.
                      </p>

                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Explore more"
                      >
                        Explore more
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/cloudinary/meta4.webp")}
                      alt="Smart Order Routing for Cryptocurrencies
                      "
                      className="image_radious cryptSmrtOrdrSmrtOrdr"
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text-center text_center_new">
                        Functions of the Crypto Smart Order Router
                      </h2>
                      <p className="text-center">
                        Smart Order Routing, or SOR for short, is an excellent
                        solution for dealing with fluctuating pricing and
                        liquidity issues. This is an automated technology that
                        assists in processing orders at the best possible price
                        across various marketplaces in real-time. SOR analyses
                        the current rate for every selected pair across several
                        exchanges and helps to locate the optimal way to make a
                        transfer in order to deliver the best offer.
                      </p>

                      {/* <Button data-toggle="modal" data-target="#myModal">
                        Let’s Discuss
                      </Button> */}
                      <div className="d-flex respozrfve_nuttn justify-content-center mt-4">
                        <div className="button_why_devee">
                          <a
                            data-toggle="modal"
                            data-target="#myModal"
                            className="m-0 mr-2"
                          >
                            Get A Demo
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="section bg-light bg_line defi-staking-list height_SIO">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_center_new">
                        Smart Order Route Configurations
                      </h2>
                      <p className="text-center">
                        Smart order routes may be set up in a variety of ways.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card_bg_whute">
                  <div className="row justify-content-center grid_ful_height_tab">
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Dark Pools</h3>
                        <p>
                          You may configure the smart route to{" "}
                          <b>prioritize dark pools</b> based on the level of
                          access provided by your broker. Dark pools have no
                          posted bids or requests and are concealed from the
                          light market.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Liquidity</h3>
                        <p>
                          You may prioritize smart order routing to{" "}
                          <b>boost liquidity</b>, which means having your share
                          requests completed even if the price is greater or
                          lower depending on whether it's a buy or sell.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Fill Prices</h3>
                        <p>
                          Smart order routing may be customized to{" "}
                          <b>enhance fill prices</b>, which implies that your
                          orders will only be filled up to the price you choose.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Specific Fill Prices</h3>
                        <p>
                          You may also use dynamic ratio indicators to{" "}
                          <b> target certain fill prices </b>such as the
                          volume-weighted average price (VWAP) or time-weighted
                          average price (TWAP) (TWAP).
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-lg-6">
                      <div className="footer_cerd">
                        <div className="row">
                          <div className="col-lg-12">
                            <Button
                              data-toggle="modal"
                              data-target="#myModal"
                              className="mt-0"
                              aria-label=" Get A Free Quotation"
                            >
                              Get A Free Quotation
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new mb-5">
                        Perks of Smart Order Routing
                      </h2>
                      <p className="text-center">
                        Smart routes are easy to use, fast, convenient, and
                        automated. They take the guesswork out of order routing.
                        The advantages of employing smart routes are summarized
                        below.
                      </p>
                    </div>
                    <ul className="row list_item_d justify-content-center">
                      <li className="col-md-6 col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/cloudinary/meta5.webp")}
                              alt="Feb-Business_9-ai"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Best-Priced Trades</h3>
                            <p>
                              SOR assures that the exchange will take place at
                              the best rate available across all connected
                              exchanges.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/cryptosmart/customer-behavior.webp")}
                              alt="Smart Contract Auditing Service Company"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Order Execution in an automated way</h3>
                            <p>
                              One of the nicest things about SOR is that it
                              decreases the amount of routine labor you have to
                              complete tenfold.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/cryptosmart/liquidity.webp")}
                              alt="Smart Contract Auditing Service Company"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Liquidity </h3>
                            <p>
                              The automated strategy also enables you smoothly
                              move significant amounts of crypto among several
                              exchanges instead of depending on a single market.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/cryptosmart/transaction.webp")}
                              alt="Smart Contract Auditing Service Company"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Fast Transaction</h3>
                            <p>
                              SOR has almost little influence on transaction
                              speed because orders are processed very
                              instantaneously.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/cryptosmart/inoperative.webp")}
                              alt="Smart Contract Auditing Service Company"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Tackles Liquidity Fragmentation</h3>
                            <p>
                              SOR evaluates the current situation of the market
                              and puts orders based on predefined rules and
                              algorithms, assisting in the transfer of assets at
                              the best possible rate.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/cryptosmart/arbitrage.webp")}
                              alt="Smart Contract Auditing Service Company"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Leverages Arbitrage Opportunities</h3>
                            <p>
                              Automated technologies can assist you in
                              capitalizing on market inefficiencies and
                              profiting from regional pricing disparities.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div className="col-lg-12 first_section_crypto">
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="m-auto mt-4 margin_top_p"
                        aria-label="
                        Get A Demo"
                      >
                        Get A Demo
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/cloudinary/sr1.webp")}
                      alt="Features of our Smart Order Routing Services"
                      className="image_radious cryptSmrtOrdrFectSmrt"
                    />
                  </div>
                  <div className="col-lg-6 d-flex align-items-center">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Features of our Smart Order Routing Services
                      </h2>

                      <ul className="list_item_sec">
                        <li>Highly Customizable</li>
                        <li>Highly Secured Protocol</li>
                        <li>Built-in remote monitoring</li>
                        <li>High Throughput</li>
                        <li>Low Latency</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 d-flex align-items-center">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Smart order routing in the cryptocurrency market
                      </h2>
                      <p>
                        Given the lack of liquidity in the cryptocurrency
                        markets, Smart Order Routing might be a highly useful
                        tool for cryptocurrency traders. There are so many
                        illiquid trading venues in the cryptocurrency market
                        that the price of the same token inside the same order
                        book can vary substantially, making institutional trades
                        inefficient. We observed the cryptocurrency industry and
                        are incorporating Smart Order Routing into their
                        Cryptocurrency trading platform.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Start A Conversation"
                      >
                        Start A Conversation
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/cloudinary/sr2.webp")}
                      alt="Features of our Smart Order Routing Services"
                      className="image_radious cryptSmrtOrdrRotngMrkt"
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2 className="mb-3">
                        Our End-to-End Smart Order Routing Development Process
                      </h2>
                      <p className="text-center mb-5">
                        Creating a Smart Order Router for your blockchain
                        business by employing Beleaf Technologies’s experts
                        strongly assists you to build your complete project in a
                        more enhanced manner. We develop your Crypto Smart Order
                        Router under the following process mentioned below.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete card_P2P_new routing">
                      <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/new/P2P/engineering.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Project Analysis</h4>
                            <p>
                              Our business analysts thoroughly examine current
                              market trends before developing the precise
                              project aim and goals for the business module.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/new/P2P/engineering.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Analysis of Client Requirements</h4>
                            <p>
                              Client requirements are determined based on their
                              business requirements, and technical resources
                              such as software, tools, and technologies to be
                              included are discussed.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/new/P2P/engineering.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Design Methodology</h4>
                            <p>
                              The Design stage allows developers to receive a
                              skeleton design of the smart order router, and the
                              design will be built in such a way that it
                              promotes an increasing number of participants on
                              the platform.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/new/P2P/engineering.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Development Stage</h4>
                            <p>
                              Following the testing process, the router platform
                              is completely automated and responsive by merging
                              front-end and back-end features.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/new/P2P/engineering.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Testing</h4>
                            <p>
                              The testing stage allows the platform to go
                              through a number of tests, such as User Acceptance
                              Testing, to determine its resistance to
                              forthcoming hack assaults and intruder attacks.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/new/P2P/engineering.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Project Implementation</h4>
                            <p>
                              Following the testing process, the created
                              exchange platform will be hosted on the client's
                              server. The platform receives post-maintenance and
                              security upgrades on a regular basis.
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-12 first_section_crypto">
                          <Button
                            data-toggle="modal"
                            data-target="#myModal"
                            className="m-auto mt-4 margin_top_p"
                            aria-label=" Hire Our Developer"
                          >
                            Hire Our Developer
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Section id="Process">
              <section className="bg-progress section our_process new_testiomial bg-light clone_eeeeeee">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="dex_third_conetnt">
                        <h2 className="mb-3">Technology Stack We employ</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cryptSmrtOrdrTechStack">
                  <Slider {...processes_newew}>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/new/CEX/GitHub-logo.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/new/CEX/node.js.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/new/CEX/AngularJS_logo.svg.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/new/CEX/React_logo_wordmark.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/new/CEX/MongoDB_Logo.svg.webp")}
                        alt="techstack"
                      />
                    </div>
                  </Slider>
                </div>
              </section>
            </Section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2 className="mb-2">
                        Why Should You Build Your Smart Order Routing Platform
                        With Us?
                      </h2>
                      <p className="text-center mb-5">
                        You can rely on a team of finance and technology
                        specialists with real-world experience establishing
                        crypto and blockchain development success stories when
                        you collaborate with Beleaf.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete new_our_furtur card_heignt_section grid_ful_height_tab">
                      <div className="row">
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/cloudinary/sr3.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Meaningful Results</h4>
                              <p>
                                We make a visible difference. We make certain
                                that you see a return on your investment.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/cloudinary/sr4.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Complete Assistance</h4>
                              <p>
                                Our work does not end with the release of the
                                product. We offer comprehensive post-delivery
                                services so you may focus on your growth.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/cloudinary/sr5.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Rapid Progress</h4>
                              <p>
                                We create goods that are tailored to your target
                                demographic. A well-planned roadmap ensures
                                seamless and rapid development and deployment.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/cloudinary/sr6.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Team of Experts</h4>
                              <p>
                                We have 500 specialists who can assist you in
                                optimizing your product, recommending the
                                optimal tech strategy, and even setting up
                                communities and campaigns.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="bg-white">
              {/* faq */}
              <article className="primary__landing-content-container">
                <div className="landing-faq-wrapper">
                  <div className="row">
                    <div className="col-lg-6">
                      <h6 className="landing-faq-left-title">
                        Frequently Asked{" "}
                        <span className="faq-span">Questions.</span> {""}
                      </h6>
                    </div>
                    <div className="col-lg-6">
                      <div>
                        <div className="container">
                          <div className="accordion" id="faq">
                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead1">
                                <button
                                  className="landing-faq-title collapsed"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#faq1"
                                  aria-expanded="true"
                                  aria-controls="faq1"
                                >
                                  What is smart order routing in Crypto?
                                </button>
                              </div>

                              <div
                                id="faq1"
                                className="collapse"
                                aria-labelledby="faqhead1"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  A smart order router (SOR) is an automated
                                  process used in online trading, which follows
                                  a set of rules that look for and assess
                                  trading liquidity.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead2">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq2"
                                  aria-expanded="true"
                                  aria-controls="faq2"
                                >
                                  What exactly is the order routing process?
                                </div>
                              </div>

                              <div
                                id="faq2"
                                className="collapse"
                                aria-labelledby="faqhead2"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Order routing is the process of transferring
                                  an order from the end user to an exchange. A
                                  customer's order may be sent straight to the
                                  exchange, mor it may be routed first to a
                                  broker, who then sends the order to the
                                  exchange. "Sart" order routing seeks to
                                  maximise transaction execution while reducing
                                  market effect.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead3">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq3"
                                  aria-expanded="true"
                                  aria-controls="faq3"
                                >
                                  What are the system specifications?
                                </div>
                              </div>

                              <div
                                id="faq3"
                                className="collapse"
                                aria-labelledby="faqhead3"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  We will configure a suitable hosted server
                                  environment for you because algorithms are run
                                  on the server. You will operate the algorithms
                                  using a lightweight front-end application with
                                  minimal system requirements.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead4">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq4"
                                  aria-expanded="true"
                                  aria-controls="faq4"
                                >
                                  What assets may the Smart Order Routing bot
                                  trade?
                                </div>
                              </div>

                              <div
                                id="faq4"
                                className="collapse"
                                aria-labelledby="faqhead4"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Bitcoin, Ethereum, and Litecoin, as well as
                                  numerous altcoins, are examples of major
                                  cryptocurrencies.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead5">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq5"
                                  aria-expanded="true"
                                  aria-controls="faq5"
                                >
                                  Is it simple to use?
                                </div>
                              </div>

                              <div
                                id="faq5"
                                className="collapse"
                                aria-labelledby="faqhead5"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Yes. The use and monitoring of bots are
                                  intended to be simple. Although the software
                                  design is quite strong, the complex stuff is
                                  hidden under the hood.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead6">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq6"
                                  aria-expanded="true"
                                  aria-controls="faq6"
                                >
                                  How does Beleaf smart order routing work?
                                </div>
                              </div>

                              <div
                                id="faq6"
                                className="collapse"
                                aria-labelledby="faqhead6"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  To optimize the outcome of trading any pairs,
                                  Beleaf uses an automated technique to locate
                                  the best available price across various
                                  exchanges.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </section>
          </span>
        </main>
      </div>

      <ServiceFooter />
    </div>
  );
}

export default Cex;
